<ng-container *iCms="'search-trending' of content">
    <h4 class="s1 m-b-3"
        *iCms="'header' of content"
        text></h4>

    <div class="pos-relative"
         [grid]="4"
         [gridColumnGap]="1">
        @switch (mode) {
        <!--klevu trending products -->
        @case ('klevu') {
        @for (model of klevuTrendingProducts | slice: 0 : 4; track model) {
        <product [model]="model"
                 [smallText]="true"
                 [gridColumn]="1"
                 [smallWishlist]="true"
                 [hideSwatches]="true"></product>
        }
        }
        <!-- icms content -->
        @case ('icms') {
        @for (item of content?.items; track item) {
        <href [link]="item.link">
            <div [attr.title]="item.title">
                <div class="ratio-1-1 overflow-hidden trending-image">
                    <local-shell />
                    <img class="rf"
                         [image]="item.image"
                         [attr.alt]="item.title">
                </div>
                <p class="m-t-3 s2"
                   *iCms="'title' of content; skipEmpty: true"></p>
                <p class="m-t-1 p2"
                   *iCms="'copy' of content; skipEmpty: true"></p>
                @if (item.cta_copy) {
                <button type="button"
                        class="m-t-3 p1 button-inline">
                    <span *iCms="'cta_copy' of content"></span>
                </button>
                }
            </div>
        </href>
        }
        }
        <!-- loader -->
        @default {
        <div class="pos-absolute fill flex flex-middle flex-justify-center">
            <i class="icon-loading"></i>
        </div>
        }
        }
    </div>
</ng-container>
